import { useThemeFromSettings } from '@/hooks/useThemeFromSettings';
import { useTheme } from '@/contexts/ThemeProvider';
import AppLoadingState from '@/components/AppLoadingState';

/**
 * Component that loads and applies theme from settings when the app mounts
 * Should be placed after AlbumProvider but before UI rendering
 */
const ThemeLoader = ({ children }: { children: React.ReactNode }) => {
  const { isThemeLoaded } = useTheme();
  // console.log("DEBUG 🔵🔵🔵: --------------- isThemeLoaded ---------- ", isThemeLoaded);
  useThemeFromSettings();

  // Show loading state until theme is fully loaded
  if (!isThemeLoaded) {
    return <AppLoadingState />;
  }

  return <>{children}</>;
};

export default ThemeLoader;